if (!customElements.get('cart-drawer-items')) {
  function debounce(fn, wait) {
    let t;
    return (...args) => {
      clearTimeout(t);
      t = setTimeout(() => fn.apply(this, args), wait);
    };
  }

  customElements.define(
    'cart-drawer-items',
    class CartDrawerItems extends HTMLElement {
      constructor() {
        super();
        this.addEventListener('change', this.onQuantityChange.bind(this));
        this.setupQuantityButtons();

        this.debouncedOnChange = debounce((event) => {
          this.onChange(event);
        }, 300);
      }

      setupQuantityButtons() {
        this.querySelectorAll('.quantity__button').forEach(button => {
          button.addEventListener('click', (evt) => {
            const button = evt.target.closest('.quantity__button');
            if (!button) return;

            const input = button.closest('.quantity').querySelector('.quantity__input');
            const currentValue = parseInt(input.value);

            if (button.name === 'minus' && currentValue === 1) {
              const cartItem = button.closest('tr.cart-item');
              if (cartItem) {
                cartItem.classList.add('cart-item--pending-remove');
              }
            }
          });
        });
      }

      onQuantityChange(event) {
        if (!event.target.matches('.quantity__input')) return;

        const quantityInput = event.target;
        const cartItem = quantityInput.closest('tr.cart-item');
        if (!cartItem) return;

        if (parseInt(quantityInput.value) === 0) {
          cartItem.classList.add('cart-item--pending-remove');
          this.debouncedOnChange(event);
        } else {
          this.debouncedOnChange(event);
        }
      }

      async onChange(event) {
        const quantityInput = event.target;
        const cartItem = quantityInput.closest('tr.cart-item');
        const itemIndex = cartItem.dataset.index;
        const quantity = parseInt(quantityInput.value);

        // Show loading state
        const loadingOverlay = cartItem.querySelector('.loading-overlay');
        if (loadingOverlay) {
          loadingOverlay.classList.remove('hidden');
        }

        try {
          const response = await fetch(window.Shopify.routes.root + 'cart/change.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json'
            },
            body: JSON.stringify({
              line: itemIndex,
              quantity: quantity
            })
          });

          const cart = await response.json();

          if (!response.ok) {
            throw new Error(response.statusText);
          }

          if (quantity === 0) {
            setTimeout(() => {
              cartItem.classList.add('cart-item--hidden');
              setTimeout(() => {
                cartItem.remove();

                // If this was the last item, refresh the page to show empty cart state
                if (cart.item_count === 0) {
                  window.location.reload();
                }
              }, 300);
            }, 300);
          }

          // Update cart totals
          const subtotalElement = document.querySelector('.totals__subtotal-value');
          if (subtotalElement) {
            subtotalElement.textContent = new Intl.NumberFormat('en-US', {
              style: 'currency',
              currency: 'USD'
            }).format(cart.total_price / 100);
          }

        } catch (error) {
          console.error('Error:', error);
          // Revert the input value if there was an error
          quantityInput.value = quantityInput.defaultValue;
        } finally {
          // Hide loading state
          if (loadingOverlay) {
            loadingOverlay.classList.add('hidden');
          }
        }
      }
    }
  )
}
